module.exports = __webpack_public_path__ + "front/img/b24.cb2c39df.jpg";